import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const ConfigurationsApi = createApi({
	reducerPath: "Configurations",
	baseQuery: fetchBaseQuery({
		baseUrl: `${process.env.REACT_APP_BACKEND2_URL}/v1`,
		credentials: "include",
	}),
	endpoints: (builder) => ({
		getAllConfigurations: builder.query({
			query: (val) => {
				const page = val.page ?? 1;
				const limit = val.limit ?? 10000;
				const search = val.search ? `&search=${val.search}` : "";
				return `/offline-config?page=${page}&limit=${limit}${search}`;
			},
		}),

		getSingleConfiguration: builder.query({
			query: (configId) => `/offline-config/${configId}`,
		}),
		addConfiguration: builder.mutation({
			query: (val) => ({
				url: `/offline-config`,
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: val,
			}),
		}),
		editConfiguration: builder.mutation({
			query: ({ id, val }) => ({
				url: `/offline-config/${id}`,
				method: "PATCH",
				headers: { "Content-Type": "application/json" },
				body: val,
			}),
		}),
		deleteConfiguration: builder.mutation({
			query: (id) => ({
				url: `/offline-config/${id}`,
				method: "DELETE",
			}),
		}),
		getSingleOfflineConfiguration: builder.query({
			query: (configId) => `/offline-config/${configId}/deets`,
		}),
	}),
});

export const {
	useGetAllConfigurationsQuery,
	useGetSingleConfigurationQuery,
	useAddConfigurationMutation,
	useEditConfigurationMutation,
	useDeleteConfigurationMutation,
	useGetSingleOfflineConfigurationQuery,
} = ConfigurationsApi;
